import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Content from 'components/Content';
import { Button, Grid, Paper, Card, CardContent, CardActions, Box } from '@material-ui/core/';
import { sendGetRequest } from '../utils/api';
import BasicDropDown from '..//components/forms/formElements/BasicDropDown';
import _ from 'lodash';
import { useTheme } from '@material-ui/core/styles';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@material-ui/data-grid';
import XlsxPopulate from 'xlsx-populate'
import TextField from '@material-ui/core/TextField';

import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	Label,
	Tooltip,
	ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
    Legend,
    Bar,
    CartesianGrid,
    BarChart,
} from 'recharts';

import { ContactsOutlined } from '@material-ui/icons';


const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#d0eff2", "#81948c", "#dee3a6"];

const stats = ['OPERATIONAL','RETIRED','DEFECTIVE','DISPOSED','TRANSFERRED','REPAIRED','BID'];

const RADIAN = Math.PI / 180;

const columns = [
    {
        field: 'toUserNames',
        headerName: 'Assignee',
        minWidth: 300,
        editable: false,
        renderCell: (params) => {
            return  <Typography variant="caption" style={{ display: "inline-block", whiteSpace: "pre-line" }}>{params.value}</Typography> 
        }
    },
    {
        field: 'assetTag',
        headerName: 'Asset Tag',
        minWidth: 200,
        editable: false,
    },
    {
        field: 'serialNo',
        headerName: 'Serial Number',
        minWidth: 400,
        editable: false,
    },
    {
        field: 'assetDesc',
        headerName: 'Asset Description',
        minWidth: 400,
        editable: false,
    },
    {
        field: 'acqCost',
        headerName: 'Acquisition Cost',
        minWidth: 200,
        editable: false,
    },
    {
        field: 'id',
        headerName: 'ID',
        minWidth: 100,
        editable: false,
    },
    {
        field: 'forReceiving',
        headerName: 'Acknowledged',
        minWidth: 100,
        editable: false,
    }

];

const renderCustomizedLabel1 = (item)=>{
    console.log("ITEM", item["Business Unit"].value);
    const radius = item.innerRadius + (item.outerRadius - item.innerRadius) * 0.5;
    const x = item.cx + radius * Math.cos(-item.midAngle * RADIAN);
    const y = item.cy + radius * Math.sin(-item.midAngle * RADIAN);
    const clickItem = () =>{
      alert();
    }
    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > item.cx ? "start" : "end"}
        dominantBaseline="central"
       
      >
        {`${(item.percent * 100).toFixed(0)}%`}
       
      </text>
    );
  }

  const renderCustomizedLabel2 = (item)=>{
     
    const { payload } = item;
        const spaces = "    ";
        return (
            <ul>
                {
                    payload.map((entry, index) => {
                        console.log("ENTRY", entry)
                        return(
                            <li key={`item-${index}`} style={{"color":`${entry.color}`, "marginRight":"25px"}}>
                                <h5>{entry.payload["Business Unit"].value}</h5>
                                <h6>TOTAL COST = {entry.payload["Total Cost"]}</h6>
                                <h6>TOTAL ITEM COUNT = {entry.payload["Total Item Count"]}</h6>
                            </li>
                        )
                    }
                    
                    )
                }
            </ul>
        );
  }

  const renderCustomizedLabel3 = (item)=>{
     
    const { payload } = item;
        
        return (
            <>
                {
                    payload.map((entry, index) => {
                        console.log("ENTRY", entry)
                        return(
                            <div key={`item-${index}`} style={{"color":`${entry.color}`}}>
                                <h5 style={{"color":`${entry.color}`}}>
                                    {entry.payload["Business Unit"].value}
                                </h5>
                                
                                
                                
                            </div>
                        )
                    }
                    
                    )
                }
            </>
        );
  }

  const useStyles = makeStyles({
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
  });
  
export default function QueryReport(props) {
    const classes = useStyles();

	const [rows, setRows] = useState([]);

    const [mainData, setMainData] = useState([]);
    const [businessUnits, setBusinessUnits] = useState([]);
    const [filter, setFilter] = useState({businessUnit: 'hedcor group', assetStat: ' ', month: ' ', year: ' ', assignee:' '});
    const [totalItems, setTotalItems] = useState({});
    const [totalCosts, setTotalCosts] = useState({});
    const [totalOperational, setTotalOperational] = useState({});
    const [totalOthers, setTotalOthers] = useState({});

    const [itemCountPerBusinessUnit, setItemCountPerBusinessUnit] = useState([]);
    
    const [itemCountPerMonth, setItemCountPerMonth] = useState([]);

    const [itemsPerStatus, setItemsPerStatus] = useState([]);

    const [itemStatusList, setItemStatusList] = useState([]);

    const [itemYearList, setItemYearList] = useState([]);

    const [itemMonthList, setItemMonthList] = useState([
        {id: 1, value: '1', displayText: 'January'},
        {id: 2, value: '2', displayText: 'February'},
        {id: 3, value: '3', displayText: 'March'},
        {id: 4, value: '4', displayText: 'April'},
        {id: 5, value: '5', displayText: 'May'},
        {id: 6, value: '6', displayText: 'June'},
        {id: 7, value: '7', displayText: 'July'},
        {id: 8, value: '8', displayText: 'August'},
        {id: 9, value: '9', displayText: 'September'},
        {id: 10, value: '10', displayText: 'October'},
        {id: 11, value: '11', displayText: 'November'},
        {id: 12, value: '12', displayText: 'December'},
        {id: 13, value: '13', displayText: 'All'},
        ]);

    const [acknowledgementList, setAcknowledgementList] = useState([
            {id: 1, value: '0', displayText: 'Received / Acknowledged'},
            {id: 2, value: '1', displayText: 'For Receiving'}
        ]);

    useEffect(() => {
        
        const getDataFromServer = async () =>{
            const res = await sendGetRequest(`/reports/overall`);
            if(res){
                setMainData(res.data);
            }
        }

        if(localStorage.getItem('businessUnits')){
            const items = JSON.parse(localStorage.getItem('businessUnits'));
            items.push({id: 'hedcor group', value: 'HEDCOR GROUP'})
            setBusinessUnits(items);
            
            console.log(items);
        }

        getDataFromServer();

		
        
    }, []);

    
    const generateListYear = () => {
        const items = [];
        const d = new Date();
        let y = d.getFullYear();
        
        let count = y - 1985;

        y = y - count;
        for(let year = y; year<=y+count; year++){

            items.push({id: year, value: year});

        }
        return items;
    }


    useEffect(() => {

        if(!_.isEmpty(businessUnits)){

            const tempYears = generateListYear();
            setItemYearList(tempYears);

            const tempItemsStatusList = [];
            for(let i = 0; i < stats.length; i++){    
                tempItemsStatusList.push({id: stats[i], value: stats[i]});
            }
            tempItemsStatusList.push({id: 'All', value: 'All'});
            setItemStatusList(tempItemsStatusList);


            console.log("PREPPING DATA");
            let assetStats;

            if(localStorage.getItem('AssetStat')){
                assetStats = JSON.parse(localStorage.getItem('AssetStat')); 
            }


            //PER BU DATA
            const tempItemsBu = [];
            for(let bu of businessUnits){
                const items = mainData.filter((i) => i.businessUnit === bu.value)

                const total_cost_of_items = items.reduce((a, b) => a + b.acqCost, 0);
                if(items.length > 0){
                    tempItemsBu.push({
                        "Total Item Count": items.length,
                        "Total Cost": total_cost_of_items,
                        "Business Unit": bu
                    });
                    // tempItemsBu.push({
                    //     name: bu,
                    //     value: items.length
                    // });
                }
            }
            
            setItemCountPerBusinessUnit(tempItemsBu);

            //PER MONTH DATA
            const tempItems = [];
			const tempMonths = [1,2,3,4,5,6,7,8,9,10,11,12];
			const months = ['','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
			for(let month of tempMonths){
				const tempRows = mainData.filter((item) => item.month === month);
                const total_cost = tempRows.reduce((a, b) => a + b.acqCost, 0);

				if(tempRows.length === 0){
					tempItems.push({
						"Month": months[month],
						"Total": 0,
						"Total Item Count": 0
					});
				}else{
					tempItems.push({
						"Month": months[month],
						"Total": total_cost,
						"Total Item Count": tempRows.length
					});
				}

			}
            console.log(tempItems)
			setItemCountPerMonth(tempItems);

            //famas 001 - item 001 -inactive

            //famas 002 - item 001 -operational-transerred


            //TO DO: Middleware - Once a FAMAS doc is approved, update all previous FAMAS ITEMS as inactive in all FAMAS Docs and update the status of the new FAMAS Doc
            //Update masterlist item based on the status of items in the NEW FAMAS DOC
            
            

            //PER ASSET STAT DATA
            const tempItemsStat = [];
            for(let i = 0; i < stats.length; i++){

                const tempItem = mainData.filter((asset) => asset.assetStat === stats[i]);
                const tempCost = tempItem.reduce((a, b) => a + b.acqCost, 0);

                tempItemsStat.push({
                    "Status": stats[i],
                    "Total Cost": tempCost,
                    "Total Items": tempItem.length
                });

            }
            console.log("STAT ITEMS", tempItemsStat)
            setItemsPerStatus(tempItemsStat);
        }

    }, [businessUnits]);

	const filterData = () =>{
        let params = "";
        console.log('FILTER', filter);
        params = `?business_unit=${filter.businessUnit}`

        if(filter.assetStat && filter.assetStat.length > 1)
        params += `&asset_stat=${filter.assetStat}`;

        if(filter.year && filter.year > 1)
        params += `&year=${filter.year}`;

        if(filter.month && filter.month > 1)
        params += `&month=${filter.month}`;

        if(filter.assignee && filter.assignee.length > 1)
        params += `&assignee=${filter.assignee.trim()}`;

        if(filter.forReceiving)
        params += `&for_receiving=${ filter.forReceiving.toString() }`;

        if(filter.assetTag)
        params += `&asset_tag=${filter.assetTag}`;

        if(filter.status && filter.status.length > 1)
        params += `&status=${filter.status.trim()}`;

        if(filter.serialNo)
        params += `&serial_no=${filter.serialNo}`;

        console.log("PARAMS", params);
        const getDataFromServer = async () =>{

            const res = await sendGetRequest(`/reports/overall${params}`);
            if(res){
                setRows(res.data);
                console.log(res.data);
            }
        }
        getDataFromServer();

    }

    const handleChange = (e) =>{
        console.log('FILTER NAME',[e.target.name], e.target.value);

        setFilter({...filter, [e.target.name]: e.target.value});

    }

    useEffect(() => {
        // const [totaItems, setTotalItems] = useState(0);
        // const [totalCosts, setTotalCosts] = useState(0);
        // const [totalOperational, setTotalOperational] = useState(0);
        // const [totalOthers, setTotalOthers] = useState(0);
        
        if(rows){
            if(rows.length > 0){
                const tmp1 = rows.reduce( (a,b) => a + b.acqCost, 0);
                setTotalItems({items: rows.length, costs: tmp1});
        
        
                const tmpItems1 = rows.filter((a) => a.assetStat.toLowerCase() === 'operational');
                const tmp2 = tmpItems1.reduce((a,b) => a + b.acqCost,0);
                setTotalOperational({items: tmpItems1.length, costs: tmp2});
        
                const tmpItems2 = rows.filter((a) => a.assetStat.toLowerCase() !== 'operational');
                const tmp3 = tmpItems2.reduce((a,b) => a + b.acqCost,0);
        
                setTotalOthers({items: tmpItems2.length, costs: tmp3});
            }
        }else{
            setTotalItems({items: 0, costs: 0});
            setTotalOperational({items: 0, costs: 0});
            setTotalOthers({items: 0, costs: 0});
        }
        

    }, [rows])


    function exportData() {
        XlsxPopulate.fromBlankAsync()
            .then(async function (workbook) {
              
                workbook.sheet(0).cell("A1").value([
                    [
                        'Business Unit', 'Department', 'Location', 'Asset Tag', 'Asset Description',
                        'Asset Status', 'Acquisition Cost'
                    ]
                ])
                for (var i = 0; i < rows.length; i++) {
                    const row = [
                        rows[i].businessUnit,
                        rows[i].deptName,
                        rows[i].location,
                        rows[i].assetTag,
                        rows[i].assetDesc,
                        rows[i].assetStat,
                        rows[i].acqCost
                    ]
                    workbook.sheet(0).cell("A" + (i + 2)).value([row])
                }
                
                workbook.outputAsync()
                    .then(function (blob) {
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            // If IE, you must uses a different method.
                            window.navigator.msSaveOrOpenBlob(blob, "FAMAS_Records_MasterList.xlsx");
                        } else {
                            var url = window.URL.createObjectURL(blob);
                            var a = document.createElement("a");
                            document.body.appendChild(a);
                            a.href = url;
                            a.download = "FAMAS_Records_MasterList.xlsx";
                            a.click();
                            window.URL.revokeObjectURL(url);
                            document.body.removeChild(a);
                        }
                    });
            })
    }

	return (
		<Content>
			<Typography component="h2" variant="h6" color="primary" gutterBottom>
			    Query Report 
		    </Typography>
            <Grid 
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
                spacing = {3}
            >
                <Grid item xs={12} md={3}>
                    <TextField
                        id="assignee"
                        label="Assignee"
                        name="assignee"
                        value={filter.assignee || ' '}
                        variant="outlined"
                        onChange={(e)=>handleChange(e)}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12} md={3}>
                    <TextField
                        id="assetTag"
                        label="Asset Tag"
                        name="assetTag"
                        value={filter.assetTag || ' '}
                        variant="outlined"
                        onChange={(e)=>handleChange(e)}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12} md={3}>
                    <TextField
                        id="serialNo"
                        label="Serial Number"
                        name="serialNo"
                        value={filter.serialNo || ' '}
                        variant="outlined"
                        onChange={(e)=>handleChange(e)}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12} md={3}>
                    <BasicDropDown 
						name="businessUnit"
						label="Business Unit"
						value={filter.businessUnit || ' '}
						onChange={(e)=>handleChange(e)}
						options={businessUnits}
						
					/>
                </Grid>
                <Grid item xs={12} md={3}>
                    <BasicDropDown 
						name="assetStat"
						label="Status"
						value={filter.assetStat || ' '}
						onChange={(e)=>handleChange(e)}
						options={itemStatusList}
						
					/>
                </Grid>
                <Grid item xs={12} md={3}>
                    <BasicDropDown 
						name="year"
						label="Year"
						value={filter.year || ' '}
						onChange={(e)=>handleChange(e)}
						options={itemYearList}
						
					/>
                </Grid>
                <Grid item xs={12} md={3}>
                    <BasicDropDown 
						name="month"
						label="Month"
						value={filter.month || ' '}
						onChange={(e)=>handleChange(e)}
						options={itemMonthList}
						
					/>
                </Grid>
                <Grid item xs={12} md={3}>
                    <BasicDropDown 
						name="forReceiving"
						label="For Receiving"
						value={filter.forReceiving || ' '}
						onChange={(e)=>handleChange(e)}
						options={acknowledgementList}
						
					/>
                </Grid>
                <Grid item xs={12} md={12} style={{justifyContent: 'center'}}>
                    <Typography align='center'>
                        <Button
                            type="submit"
                            onClick={(e)=>{filterData(e)}}
                            variant="contained"
                            color="primary"
                            size="large"
                            startIcon={<DynamicFeedIcon />}
                        >
                                    Filter
                        </Button>
                    </Typography>
                    
                   
                </Grid>
            </Grid>
            <hr/>
            <Grid 
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
                spacing = {3}
            >
                <Grid item xs={12} md={4}>
                <Card  variant="outlined">
                    <CardContent>
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Total Items
                        </Typography>
                        <Typography style={{color:"blue"}} variant="h5" component="h2">
                            { totalItems.costs ? `Php ${totalItems.costs.toLocaleString()}` : null}
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary">
                            {`Line Items: ${totalItems.items}`}
                        </Typography>
                        <Typography variant="body2" component="p">
                            
                        <br />
                            
                        </Typography>
                    </CardContent>
                  
                </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                <Card  variant="outlined">
                    <CardContent>
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Operational
                        </Typography>
                        <Typography style={{color:"green"}} variant="h5" component="h2">
                            { totalOperational.costs ? `Php ${totalOperational.costs.toLocaleString()}` : null}
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary">
                            {`Line Items: ${totalOperational.items}`}
                        </Typography>
                        <Typography variant="body2" component="p">
                            
                        <br />
                            
                        </Typography>
                            
                        
                    </CardContent>
                  
                </Card>
                </Grid>
                
                <Grid item xs={12} md={4}>
                <Card  variant="outlined">
                    <CardContent>
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Retired / Bid / etc...
                        </Typography>
                        <Typography style={{color:"red"}} variant="h5" component="h2">

                            { totalOthers.costs ? `Php ${totalOthers.costs.toLocaleString()}` : null}
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary">
                            {`Line Items: ${totalOthers.items}`}
                        </Typography>
                        <Typography variant="body2" component="p">
                            
                        <br />
                            
                        </Typography>
                    </CardContent>
                  
                </Card>
                </Grid>
                <Grid item xs={12} md={12}>

                    <div style={{ height: 600, width: '100%' }}>
                        {
                            rows ? 
                                <DataGrid
                                rows={rows}
                                rowHeight={100} 
                                columns={columns}
                                pageSize={50}
                                rowsPerPageOptions = {[50, 75, 100]} 
                                
                                disableSelectionOnClick
                                
                                />
                            : 
                                <div></div>

                        }
                        
                    </div>

                </Grid>
                <Grid item xs={12} md={12}>

                    <Typography align='center'>
                        <Button
                            type="submit"
                            onClick={(e)=>{exportData(e)}}
                            variant="contained"
                            color="primary"
                            size="large"
                            startIcon={<DynamicFeedIcon />}
                        >
                                    Export
                        </Button>
                    </Typography>

                </Grid>
            </Grid>
            
            
              
                
            
        </Content>
	);
}
